<ds-themed-search [showCsvExport]="true" [trackStatistics]="true"></ds-themed-search>
